import { render, staticRenderFns } from "./newPurchase.vue?vue&type=template&id=cfd45550&scoped=true&"
import script from "./newPurchase.vue?vue&type=script&lang=js&"
export * from "./newPurchase.vue?vue&type=script&lang=js&"
import style0 from "./newPurchase.vue?vue&type=style&index=0&id=cfd45550&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfd45550",
  null
  
)

export default component.exports